// StyledPermissionCards.tsx
import React from "react";
import { Box, Switch, Tooltip, Typography } from "@mui/material";
import { SettingCardWrapper } from "@ui/components/card/SettingCardWrapper";
const DEFAULT_PERMISSIONS = [
    "read",
    "update",
    "create",
    "delete",
];
const StyledPermissionCards = ({ rows, permissions = DEFAULT_PERMISSIONS, rolePermissions, onChange, isDisabled = () => false, t, isAllDisabled = false, }) => {
    const isDeleteRestricted = (module, permission) => permission === "delete" &&
        ["roles", "vdkevents"].includes(module.toLowerCase());
    return (React.createElement(React.Fragment, null, rows.map((module) => (React.createElement(SettingCardWrapper, { key: module },
        React.createElement(Typography, { variant: "h6", sx: { mb: 1.5 } }, t(`modules:modulesList.${module.toLowerCase()}`)),
        permissions.map((permission, index) => {
            var _a;
            const restricted = isDeleteRestricted(module, permission);
            const disabled = restricted || isDisabled(module, index) || isAllDisabled;
            return (React.createElement(React.Fragment, { key: `${module}-${permission}` },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: 38,
                        mb: 0.5,
                    } },
                    React.createElement(Typography, { variant: "body2", sx: {
                            color: "#212B36",
                        } }, t(`modules:rolesPermissions.${permission}`)),
                    restricted ? (React.createElement(Tooltip, { title: t("actions.notAllowed"), arrow: true },
                        React.createElement("span", null,
                            React.createElement(Switch, { checked: false, disabled: true, color: "primary", sx: { visibility: "hidden" } })))) : (React.createElement(Switch, { checked: ((_a = rolePermissions[module]) === null || _a === void 0 ? void 0 : _a[permission]) || false, onChange: (e) => onChange(module, permission, e.target.checked), disabled: disabled, color: "primary" })))));
        }))))));
};
export default StyledPermissionCards;
